// extracted by mini-css-extract-plugin
export default {"container_one":"ui_container_one__wX1DQ","container_one_right":"ui_container_one_right__u8OlK","card":"ui_card__cdT4b","container_two":"ui_container_two__Yxeig"};